export type EnvironmentName = 'local' | 'dev' | 'prod' | 'knox-prod'

export const isEnvironmentName = (
  environment: string | undefined,
): environment is EnvironmentName => {
  switch (environment) {
    case 'local':
    case 'dev':
    case 'prod':
    case 'knox-prod':
      return true
    default:
      return false
  }
}

export const getEnvironmentUrl = (
  urls: Record<EnvironmentName, string>,
  environment: string | undefined,
  fallback: EnvironmentName = 'local',
) => (isEnvironmentName(environment) ? urls[environment] : urls[fallback])
